import { api } from '@/apis';
import { encodeParams, log } from '@/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useUsers() {
  const queryKey = ['users'];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const searchParams = encodeParams({
        projection: {
          _id: false,
          userId: true,
          emailAddress: true,
          forenames: true,
          surname: true,
          displayName: true,
          personCode: true,
          lastLoggedTime: true,
        },
      });

      log('Read', 'Users');

      return api.get('users', { searchParams, signal }).json();
    },
    placeholderData: [],
    staleTime: 1000 * 60 * 60,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
